import React from 'react';
import { hideConversionBarUntilScroll } from 'utils/hideConversionBarUntilScroll';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import { blockMapping } from './blockMapping';

type Props = {
  type: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fields: any | null;
  config?: unknown;
};

const ContentBlocks = ({
  type,
  fields,
  config = null,
}: Props): JSX.Element | null => {
  const blockType = blockMapping[type];
  const inspectorProps = useContentfulInspectorMode({
    entryId: fields?.sys?.id,
  });

  if (!blockType) {
    return null;
  }

  if (
    fields &&
    ['richText', 'RichText', 'ContentTypeRichText'].includes(type)
  ) {
    return React.createElement(blockType, {
      fields: fields.content || fields.textContent,
      spacing: true,
      config,
      inspectorProps,
    });
  }

  // types are mapped to components in blockMapping.ts
  const funnelPropsOrNull =
    type === 'blockFunnel' || type === 'BlockFunnel'
      ? { useShadow: true, onInteraction: hideConversionBarUntilScroll }
      : null;
  return React.createElement(blockType, {
    ...fields,
    ...(config ? { config } : null),
    ...funnelPropsOrNull,
    inspectorProps,
    spacing: true,
  });
};

export default ContentBlocks;
